<template>
  <div>
    <!-- 头部start -->
    <crumbs :activeIndex="2"></crumbs>
    <!-- 头部 end-->
    <!-- 广告start -->
    <div class="y-advertisement"> <img src="../../static/img/guanggao.png" alt=""></div>
    <!-- 广告end -->
    <!-- 导航start -->
    <div class="y-navigation">
      <div class="min y-navigation-box">
        <div><router-link to="/">首页 ></router-link>展馆概况</div>
      </div>
    </div>
    <!-- 导航end -->
    <div class="information-list min">
      <div class="information-left clear">
        <!-- 列表start -->
        <div class="information-box clear">
          <div class="info-icon">  <img src="../../static/img/p1.png" alt=""> </div>
          <div class="info-text">
            <div class="info-text-title">超萌动物</div>
            <div class="info-sub-paragraph">
              在这个世界上有各种各样的令人惊叹的动物，
              然而我们认为其中的一些非常特别。我们喜
              爱它们的大眼睛或者毛茸茸的脸庞...
            </div>
            <p class="info-line"></p>
            <div class="info-time">
              时间：2021-07-18至2021-06-10 来源：朔州市科学技术馆短期展厅
            </div>
            <div class="see-look">
              查看详情
              <img src="../../static/img/more.png" alt="" class="more" />
            </div>
          </div>
        </div>
        <!-- 列表end -->
        <!-- 列表start -->
        <div class="information-box clear">
          <div class="info-icon"><img src="../../static/img/p3.png" alt=""> </div>
          <div class="info-text">
            <div class="info-text-title">超萌动物</div>
            <div class="info-sub-paragraph">
              在这个世界上有各种各样的令人惊叹的动物，
              然而我们认为其中的一些非常特别。我们喜
              爱它们的大眼睛或者毛茸茸的脸庞...
            </div>
            <p class="info-line"></p>
            <div class="info-time">
              时间：2021-07-18至2021-06-10 来源：朔州市科学技术馆短期展厅
            </div>
            <div class="see-look">
              查看详情
              <img src="../../static/img/more.png" alt="" class="more" />
            </div>
          </div>
        </div>
        <!-- 列表end -->
        <!-- 列表start -->
        <div class="information-box clear">
          <div class="info-icon"><img src="../../static/img/p4.png" alt=""> </div>
          <div class="info-text">
            <div class="info-text-title">超萌动物</div>
            <div class="info-sub-paragraph">
              在这个世界上有各种各样的令人惊叹的动物，
              然而我们认为其中的一些非常特别。我们喜
              爱它们的大眼睛或者毛茸茸的脸庞...
            </div>
            <p class="info-line"></p>
            <div class="info-time">
              时间：2021-07-18至2021-06-10 来源：朔州市科学技术馆短期展厅
            </div>
            <div class="see-look">
              查看详情
              <img src="../../static/img/more.png" alt="" class="more" />
            </div>
          </div>
        </div>
        <!-- 列表end -->
      </div>

      <div class="information-right clear">
        <!-- 列表start -->
        <div class="information-box clear">
          <div class="info-icon"><img src="../../static/img/p5.png" alt=""> </div>
          <div class="info-text">
            <div class="info-text-title">超萌动物</div>
            <div class="info-sub-paragraph">
              在这个世界上有各种各样的令人惊叹的动物，
              然而我们认为其中的一些非常特别。我们喜
              爱它们的大眼睛或者毛茸茸的脸庞...
            </div>
            <p class="info-line"> </p>
            <div class="info-time">
              时间：2021-07-18至2021-06-10 来源：朔州市科学技术馆短期展厅
            </div>
            <div class="see-look">
              查看详情
              <img src="../../static/img/more.png" alt="" class="more" />
            </div>
          </div>
        </div>
        <!-- 列表end -->
        <!-- 列表start -->
        <div class="information-box clear">
          <div class="info-icon"><img src="../../static/img/p6.png" alt=""></div>
          <div class="info-text">
            <div class="info-text-title">超萌动物</div>
            <div class="info-sub-paragraph">
              在这个世界上有各种各样的令人惊叹的动物，
              然而我们认为其中的一些非常特别。我们喜
              爱它们的大眼睛或者毛茸茸的脸庞...
            </div>
            <p class="info-line"></p>
            <div class="info-time">
              时间：2021-07-18至2021-06-10 来源：朔州市科学技术馆短期展厅
            </div>
            <div class="see-look">
              查看详情
              <img src="../../static/img/more.png" alt="" class="more" />
            </div>
          </div>
        </div>
        <!-- 列表end -->
        <!-- 列表start -->
        <div class="information-box clear">
          <div class="info-icon"><img src="../../static/img/p1.png" alt=""></div>
          <div class="info-text">
            <div class="info-text-title">超萌动物</div>
            <div class="info-sub-paragraph">
              在这个世界上有各种各样的令人惊叹的动物，
              然而我们认为其中的一些非常特别。我们喜
              爱它们的大眼睛或者毛茸茸的脸庞...
            </div>
            <p class="info-line"></p>
            <div class="info-time">
              时间：2021-07-18至2021-06-10 来源：朔州市科学技术馆短期展厅
            </div>
            <div class="see-look">
              查看详情
              <img src="../../static/img/more.png" alt="" class="more" />
            </div>
          </div>
        </div>
        <!-- 列表end -->
      </div>
    </div>
       <!-- 友情链接start -->
    <div class="links">
      <div class="links-box min">
        <div class="links-list">
          <ul>
            <li class="link-text">
              <img
                class="links-icon"
                src="../../static/img/lianjie.png"
                alt=""
              />
              友情链接
            </li>
            <li><span>中国科学技术协会</span></li>
            <li><span>中国数字科技馆</span></li>
            <li><span>山西省科技馆</span></li>
            <li><span style="border: none">山西省科学技术协会</span></li>
          </ul>
        </div>
        <div class="links-top">TOP</div>
      </div>
    </div>
    <!-- 友情链接end -->
    <!-- 底部 start-->
    <Footer></Footer>
    <!-- 底部 end-->
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods:{

  }
};
</script>

<style scoped>
.y-advertisement {
  width: 100%;
  height: 340px;

}

.information-list {
  display: flex;
}
.information-left {
  width: 50%;
  float: left;
}
.information-right {
  width: 50%;
  float: left;
}
.information-box {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
}
.information-box .info-icon {
  width: 238px;
  height: 336px;
  float: left;
 
}
.info-icon img{
  width: 100%;
  height: 100%;
}
.information-box .info-text {
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
  padding-left: 28px;
  width: 309px;
  float: left;
  text-align: left;
  padding-bottom: 35px;
}
.info-line {
  border: 1px solid #e9ebf0;
  margin-top: 35px;
}
.info-time {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-top: 25px;
}
.see-look {
  width: 108px;
  height: 38px;
  background: rgba(255, 255, 255, 0);
  border: 1px solid #cdcfd3;
  border-radius: 5px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  text-align: center;
  margin-top: 10px;
}
.more {
  display: inline-block;
  vertical-align: middle;
  width: 14px;
  height: 14px;
}
.clear {
  clear: both;
}
.info-text-title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.info-sub-paragraph {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 设置行数 */
  -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/view/exhibitionItem.vue